import { render, staticRenderFns } from "./FixedBackground.vue?vue&type=template&id=7ffb2f6e"
var script = {}
import style0 from "./FixedBackground.vue?vue&type=style&index=0&id=7ffb2f6e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports